import { useParameter } from '../../../shared';

export function useDescription() {
  const [business] = [1]; //useParameter<number>("@business-units");
  const description = Number(business) === 2 ? [
    'Width of columns shows share of crops relative to total field crop value',
    'Height of columns shows share of countries relative to crop value of specific crop',
    '% shows change from last year to this year',
    'Source: USDA PS&D (Field crops), FAO (Fruits & Vegetables), Global Insight and Eurostat for individual EU countries'

  ] :
    [
      "Width of columns shows  share of crops relative to total field crop crop value",
      "Height of columns shows share of countries relative to crop value of specific crop",
      "% shows change from last year to this year",
      "Source:  USDA PS&D (Field crops), FAO (Fruits & Vegetables), FAPRI (Sugar Crops) and Global Insight"
    ]

  return description;
}